function OffenderScheduleDisplay(aSchedule, aUseDayFlags, aSkipDaySettings) {
    "use strict";
    this.__type = 'OffenderSchedule:www.veritracks.com';
    this.Id = aSchedule.Id;
    this.Version = aSchedule.Version;

    this.StartTimeUTC = aSchedule.StartTimeUTC;
    this.EndTimeUTC = aSchedule.EndTimeUTC;
    this.StartDateUTC = aSchedule.StartDateUTC;
    this.EndDateUTC = aSchedule.EndDateUTC;
    this.EndTime = aSchedule.EndTime;
    this.IsActive = aSchedule.IsActive;
    this.IsNoSchedule = aSchedule.IsNoSchedule;
    this.IsRecurring = aSchedule.IsRecurring;

    this.StartTimeLocal = aSchedule.StartTimeLocal;
    this.EndTimeLocal = aSchedule.EndTimeLocal;
    this.UpdatedScheduleLocal = aSchedule.UpdatedScheduleLocal;
    this.UpdatedByAppUserId = aSchedule.UpdatedByAppUserId;

    if (aUseDayFlags) {
        this.IsFriday = aSchedule.IsFriday;
        this.IsMonday = aSchedule.IsMonday;
        this.IsSaturday = aSchedule.IsSaturday;
        this.IsSunday = aSchedule.IsSunday;
        this.IsThursday = aSchedule.IsThursday;
        this.IsTuesday = aSchedule.IsTuesday;
        this.IsWednesday = aSchedule.IsWednesday;
    } else {
        this.IsFriday = false;
        this.IsMonday = false;
        this.IsSaturday = false;
        this.IsSunday = false;
        this.IsThursday = false;
        this.IsTuesday = false;
        this.IsWednesday = false;
    }
    this.Name = aSchedule.Name;
    this.ZoneName = aSchedule.ZoneName;
    this.StartTime = aSchedule.StartTime;

    var lEnrollee = GetEnrollee(aSchedule.EnrolleeId);

    if (!displayDSTSchedules()) {
        if (FixGetTime(this.StartTime, lEnrollee.TimeZoneId) == 1 && !aSkipDaySettings) {
            this.IsSaturday = aSchedule.IsSunday;
            this.IsSunday = aSchedule.IsMonday;
            this.IsMonday = aSchedule.IsTuesday;
            this.IsTuesday = aSchedule.IsWednesday;
            this.IsWednesday = aSchedule.IsThursday;
            this.IsThursday = aSchedule.IsFriday;
            this.IsFriday = aSchedule.IsSaturday;
        }
        else if (FixGetTime(this.StartTime, lEnrollee.TimeZoneId) == 0) {
            this.IsSaturday = aSchedule.IsFriday;
            this.IsSunday = aSchedule.IsSaturday;
            this.IsMonday = aSchedule.IsSunday;
            this.IsTuesday = aSchedule.IsMonday;
            this.IsWednesday = aSchedule.IsTuesday;
            this.IsThursday += aSchedule.IsWednesday;
            this.IsFriday = aSchedule.IsThursday;
        }
    }

    this.EnrolleeId = aSchedule.EnrolleeId;
    this.EntityId = aSchedule.EntityId;
    this.IsEnabled = aSchedule.IsEnabled;
    this.IsForcedLeave = aSchedule.IsForcedLeave;
    this.ScheduleType = aSchedule.ScheduleType;
    this.ZoneScheduleType = aSchedule.ZoneScheduleType;
    this.TitleUpdatedFlag = aSchedule.TitleUpdatedFlag;
    this.CreateAutoExceptionFlag = 0;
    this.TravelScheduleFlag = aSchedule.TravelScheduleFlag;
}
if (typeof exports !== 'undefined') {
    module.exports = OffenderScheduleDisplay;
}